import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/it/messages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc0080d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc0080d0', __exports__)) {
    api.reload('bc0080d0', __exports__)
  }
  
}


export default __exports__